// @file Dark mode store
import { observeDarkMode } from 'bits/dark_mode'
import debounce from 'lodash.debounce'
import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export const useDarkModeStore = defineStore('darkMode', () => {
  const isAutoDetectDarkMode = ref(true)
  const browserDarkModeValue = ref(false)
  const userDarkModeValue = ref(false)
  const isDarkMode = computed(() => (isAutoDetectDarkMode.value ? browserDarkModeValue.value : userDarkModeValue.value))
  const unobserveDarkMode = observeDarkMode(
    debounce((newBrowserDarkModeValue) => (browserDarkModeValue.value = newBrowserDarkModeValue), 100),
  )
  return {
    isAutoDetectDarkMode,
    browserDarkModeValue,
    userDarkModeValue,
    isDarkMode,
    unobserveDarkMode,
  }
})
